import axios from "axios";
import { axiosHyperwolfDevClient } from "axiosClient";
import { axiosHyperwolfClient } from "axiosClient";
import axiosClientDistribution from "axiosClient/indexDistribution";
import axiosClientHyperDrive from "axiosClient/indexHyperdrive";
import { getQueryString } from "utilities/common";


export async function getServiceTimeAPI() {
  return await axiosHyperwolfDevClient.get('api/v1/get/service/time')
}

export async function updateServiceTimeAPI(data) {
  return await axiosHyperwolfDevClient.post('api/v1/update/service/time', data)
}

export async function getProcessTimeAPI() {
  return await axiosHyperwolfDevClient.get('api/v1/get/process/time')
}

export async function updateProcessTimeAPI(data) {
  return await axiosHyperwolfDevClient.post('api/v1/update/process/time', data)
}

export async function getPackageTimeAPI() {
  return await axiosHyperwolfDevClient.get('api/v1/get/package/time')
}

export async function updatePackageTimeAPI(data) {
  return await axiosHyperwolfDevClient.post('api/v1/update/package/time', data)
}

export async function updateStatusAPI(data) {
  return await axiosHyperwolfClient.post('api/v1/canpay/update/status', data)
}

export async function fetchUpdateStatusAPI() {
  return await axiosHyperwolfClient.get('api/v1/canpay/get/status')
}

export async function gettransactionsListAPI(data) {
  return await axiosHyperwolfDevClient.get(`api/v1/canpay/fetch/transactions?${getQueryString(data)}`)
}

export async function UpdateRefundStatusAPI(data) {
  return await axiosHyperwolfDevClient.post('api/v1/canpay/update/order/status', data)
}

export async function fetchEmployeesListAPI(data) {
  return await axiosHyperwolfDevClient.get(`api/v1/blaze/employees?${getQueryString(data)}`)
}

export async function fetchLogCanpayAPI(data) {
  return await axiosHyperwolfDevClient.get(`api/v1/canpay/logs/${data}`)
}

export async function fetchTimeSlotDataAPI(filters) {
  return await axiosHyperwolfClient.get(`api/v1/timeslots/list?${getQueryString(filters)}`)
}
//  end pointssssssss
export async function fetchSlotLogsAPI(data) {
  return await axiosHyperwolfClient.get(`api/v1/timeslots/activity/logs?${getQueryString(data)}`)
}

export async function exportSlotDataAPI() {
  return await axiosHyperwolfClient.get('api/v1/timeslots/6890333ad05e3b2384e39d7b/slots/6890338e3fe23d23eefdeda3')
}

export async function addSlotsDaysAPI(data) {
  return await axiosHyperwolfClient.post('api/v1/timeslots/create', data)
}

export async function deleteTimeSlotAPI(id, data) {
  return axiosHyperwolfClient.delete(`api/v1/timeslots/${id?.dayID}/slots/${id?.slotid}`, data);
}

export async function getSlotsDaysAPI(dayIds) {
  return axiosHyperwolfClient.get(`api/v1/timeslots/day/${dayIds}`);
}

export async function updateSlotsDaysAPI(data, id) {
  return await axiosHyperwolfClient.put(`api/v1/timeslots/update/${id}`, data)
}

export async function slotRollBackDataAPI(id) {
  return await axiosHyperwolfClient.put(`api/v1/timeslots/activity/logs/rolledBack/${id}`)
}

// sub regions
export async function addSubRegionAPI(data) {
  return await axiosClientDistribution.post(`api/v1/admin/region/add/sub`, data)
}
export async function getSubRegionAPI(data) {
  return await axiosClientDistribution.get(`api/v1/admin/region/sub/list?${getQueryString(data)}`)
}
export async function getUnassignedSubRegionAPI(data) {
  return await axiosClientDistribution.get(`api/v1/admin/region/get/unassigned/subRegions?${getQueryString(data)}`)
}
export async function getUnassignedDriversAPI(data) {
  return await axiosClientDistribution.get(`api/v1/admin/region/get/unassigned/drivers?${getQueryString(data)}`)
}
export async function getSubRegionDetailsAPI(id) {
  return await axiosClientDistribution.get(`api/v1/admin/region/sub/show/${id}`)
}
export async function getBlazeRegionsAPI() {
  return await axiosHyperwolfDevClient.get(`api/v1/regions/get`)
}
export async function updateSubRegionAPI(data) {
  const { _id, ...rest } = data || {}
  return await axiosClientDistribution.put(`api/v1/admin/region/sub/edit/${_id}`, rest)
}
export async function deleteSubRegionAPI(id) {
  return await axiosClientDistribution.delete(`api/v1/admin/region/sub/delete/${id}`)
}

// regions
export async function addRegionAPI(data) {
  return await axiosClientDistribution.post(`api/v1/admin/region/add`, data)
}
export async function getRegionAPI(data) {
  return await axiosClientDistribution.get(`api/v1/admin/region/list?${getQueryString(data)}`)
}
export async function getRegionDetailsAPI(id) {
  return await axiosClientDistribution.get(`api/v1/admin/region/get/${id}`)
}
export async function updateRegionAPI(data) {
  const { regionId, ...rest } = data || {}
  return await axiosClientDistribution.put(`api/v1/admin/region/update/${regionId}`, rest)
}
export async function deleteRegionAPI(id) {
  return await axiosClientDistribution.delete(`api/v1/admin/region/delete/${id}`)
}
export async function unassignSubRegionAPI(data) {
  return await axiosClientDistribution.delete(`api/v1/admin/region/delete/sub/assign/driver?subRegionId=${data.subRegionId}&regionId=${data.regionId}`)
}
export async function unassignDriversAPI(data) {
  return await axiosClientDistribution.get(`api/v1/admin/region/bulk/unassign/driver`)
}
export async function updateAssignedSubRegionAPI(data) {
  const { subRegionId, regionId, driverId, status } = data || {}
  return await axiosClientDistribution.put(`api/v1/admin/region/update/sub/assign/driver?subRegionId=${subRegionId}&regionId=${regionId}`, { driverId, status })
}
export async function fetchHolidaysListAPI(data) {
  return axiosHyperwolfClient.get(`api/v1/admin/shop/time/get/holiday/listing?searchTerm=${data?.searchTerm ? data?.searchTerm : ""}`);
}
export async function fetchBRBListAPI(data) {
  return axiosHyperwolfClient.get(`api/v1/admin/shop/time/brb/graphic?${getQueryString(data)}`);
}

export async function fetchShopTimeListAPI(data) {
  return axiosHyperwolfClient.get(`api/v1/admin/shop/time/list?searchTerm=${data?.searchTerm ? data?.searchTerm : ""}`);
}

export async function fetchShopSlotLogsAPI(data) {
  return axiosHyperwolfClient.get(`api/v1/admin/shop/time/activity/logs?${getQueryString(data)}`);
}


export async function CreateShopTimingAPI(data) {
  return await axiosHyperwolfClient.post('api/v1/admin/shop/time/create/shop/timings', data)
}

export async function CreateHolidayManagementAPI(data) {
  return await axiosHyperwolfClient.post('api/v1/admin/shop/time/create/holiday/management', data)
}

export async function deleteShopTimeSlotAPI(id, data) {
  return axiosHyperwolfClient.delete(`api/v1/admin/shop/time/${id?.dayID}/slots/${id?.slotid}?updatedBy=${data?.updatedBy}`);
}

export async function deleteHolidaySlotAPI(id, data) {
  if (id?.type === 'date') {
    return axiosHyperwolfClient.delete(`api/v1/admin/shop/time/bulk/delete/holiday/${id.date}?updatedBy=${data?.updatedBy}`);
  } else {
    return axiosHyperwolfClient.delete(`api/v1/admin/shop/time/delete/holiday/${id}?updatedBy=${data?.updatedBy}`);
  }
}


export async function fetchHolidaysLogsAPI(data) {
  return axiosHyperwolfClient.get(`api/v1/admin/shop/time/holiday/management/activity/logs?${getQueryString(data)}`);
}

export async function CreateBRBAPI(data) {
  return await axiosHyperwolfClient.post('api/v1/admin/shop/time/create/brb/graphic', data)
}

export async function fetchBRBGraphicsLogsAPI(data) {
  return axiosHyperwolfClient.get(`api/v1/admin/shop/time/brb/graphic/activity/logs?${getQueryString(data)}`);
}

export async function fetchBRBByIDApi(dayIds) {
  return axiosHyperwolfClient.get(`api/v1/admin/shop/time/brb/graphic/${dayIds}`);
}

export async function updateBRBByIDApi(data, id) {
  return axiosHyperwolfClient.put(`api/v1/admin/shop/time/update/brb/graphic/${id}`, data);
}

export async function deleteBrbGraphicsByIdAPI(id, data) {
  return axiosHyperwolfClient.delete(`api/v1/admin/shop/time/brb/graphic/${id}?updatedBy=${data?.updatedBy}`);
}

export async function fetchHolidayByIDApi(dayIds) {
  return axiosHyperwolfClient.get(`api/v1/admin/shop/time/holiday/detail/${dayIds}`);
}
export async function updateHolidayByIDApi(data, id) {
  return axiosHyperwolfClient.patch(`api/v1/admin/shop/time/update/holiday/management/${id}`, data);
}

export async function fetchDayWiseSlotsApi(id) {
  return axiosHyperwolfClient.get(`api/v1/admin/shop/time/day/${id}`);
}


export async function EditShopTimingApi(data, id) {
  return await axiosHyperwolfClient.put(`api/v1/admin/shop/time/update/${id}`, data)
}